<template>
    <div class="documentation">
        <Breadcumb title="Ajouter une bonne pratique" :breadcumb-data="breadcumbData"></Breadcumb>
        <b-form @submit="addForumArticle" class="cardcontainer" id="docform">
                    <b-card class="mb-3 pb-3">
                        <b-form-group label="Titre de l'article" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                            <b-input type="text" placeholder="Titre" v-model="title" :state="errors.title ? 'invalid': ''"/>
                            <div v-if="errors['title']" class="invalid-tooltip">{{ errors['title'][0] }}</div>
                        </b-form-group>
                        <b-form-group label="Article en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                            <quill-editor
                                    v-model="article"
                                    :options="editorOption"
                                    @change="onEditorChange($event)"
                                    style="height:500px;"
                            />
                        </b-form-group>
                    </b-card>
                <!-- Buttons -->
                <b-btn variant="primary" slot="finish" @click="addForumArticle">Ajouter</b-btn>
        </b-form>
    </div>
</template>
<script>
    import Breadcumb from '../components/breadcumb';

    export default {
        name: 'adminDocumentationAdd',
        components: { Breadcumb, },
        mounted() {
        },
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Bonnes pratiques', href: '/share/guidelines/' },
                    { text: 'Ajouter une bonne pratique', active: true },
                ],
                article: '',
                title: '',
                errors: [],
                editorOption: {
                    // Some Quill options...
                }
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addForumArticle: function (e) {
            
            }
        },
    };
</script>
